import { NumericFormat } from 'react-number-format';

/**
 * Get currency symbol from currency code
 * @param {string} divisa - Currency code (e.g., 'EUR', 'USD')
 * @returns {string} Currency symbol
 */
export const getCurrencySymbol = divisa => {
  if (!divisa) return '€';

  const symbols = {
    EUR: '€',
    USD: '$',
    GBP: '£',
    JPY: '¥',
    CHF: 'CHF',
    AUD: 'A$',
    CAD: 'C$',
    CNY: '¥',
  };
  return symbols[divisa.toUpperCase()] || '€';
};

/**
 * Currency format component for displaying formatted currency values
 * @param {Object} props
 * @param {number} props.value - Amount to format
 * @param {string} props.divisa - Currency code (defaults to 'EUR')
 * @returns {JSX.Element} Formatted currency display
 */
export const CurrencyFormatComponent = ({ value, divisa }) => {
  const actualDivisa = divisa || 'EUR';

  return (
    <NumericFormat
      value={value}
      displayType={'text'}
      thousandSeparator={'.'}
      decimalSeparator={','}
      suffix={` ${getCurrencySymbol(actualDivisa)}`}
      decimalScale={2}
      fixedDecimalScale={true}
    />
  );
};

